
import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom"
import RightOrderCard from './rightOrderCard'
import ReportCard from './reportCard'
import SalesCard from './salesCard';
import Header from './header';
import { useDispatch, useSelector } from "react-redux";
import { getActiveOrderList,getAllOrderList} from '../../../redux/actions/orderAction';
import { OrderStatus } from '../../orders/OrderEnum'

import '../home.css';

  const DashBoard=({handlePageSelect,user})=>{
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [alldOrderHistory,setAlldOrderHistory]=useState([])

    const [completedOrderList,setCompletedOrderList]=useState([])
    const [newOrderArray,setNewOrderArray]=useState([])
    const [returnOrderList,setReturnOrderList]=useState([])
    const [canceledOrderList,setCanceledOrderList]=useState([])

   
    const allOrderList = useSelector((state) => state.getAllOrderReducer);
   // const activeOrderList = useSelector((state) => state.getActiveOrderReducer);


    useEffect(() => {
      if(user){
        dispatch(getAllOrderList(user));
        dispatch(getActiveOrderList(user));
      }
  }, [user])

//   useEffect(() => {
//     if(activeOrderList){
//       setActiveOrderArray(activeOrderList)
//     }

// }, [activeOrderList])

useEffect(() => {
  if(allOrderList){
    setAlldOrderHistory(allOrderList)

    const newOrderList=allOrderList.filter(o=>o.orderStatus===OrderStatus.ASSIGNED)
    const completedOrderList=allOrderList.filter(o=>o.orderStatus===OrderStatus.COMPLETED)
    const returnOrderList=allOrderList.filter(o=>o.orderStatus===OrderStatus.RETURN)
    const canceledOrderList=allOrderList.filter(o=>o.orderStatus===OrderStatus.CANCELED)

    setNewOrderArray(newOrderList)
    setCompletedOrderList(completedOrderList)
    setReturnOrderList(returnOrderList)
    setCanceledOrderList(canceledOrderList)
  }

}, [allOrderList])

 const chartData = [
  ["Orders", "Count"],
  ["New Order", newOrderArray.length],
  ["Completed Order",completedOrderList.length],
  ["Return Order", returnOrderList.length],
  ["Cancel Order", canceledOrderList.length],
];

const salesData = [
  ["Day", "Sales"],
  ["Yesterday", newOrderArray.length],
  ["Today",completedOrderList.length],

];

    return <>
        <Header />
        <div className='row-home'>
          <div className='col-lg-8'>
            <div className='row'>
      <div className='column-home'>
              <ReportCard chartData={chartData} total={alldOrderHistory?.length || 0}/>
              <SalesCard chartData={salesData} total={alldOrderHistory?.length || 0}/>
              </div>
            </div>
          </div>
          <div className='rightContainer'>
          <RightOrderCard title={'New Order'} subtitle={`Total (${newOrderArray?.length || 0})`} list={newOrderArray} handlePageSelect={handlePageSelect}/>
          <RightOrderCard title={'Top Products'} subtitle={'Today'} list={[]}/>
          </div>
        </div>
    </>
  }

  export default DashBoard;